/**
 * @desc 平台-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.PlatformResponseDto>>;
export function request(
  params: API.basics.platform.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platform/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
